import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { NonBuyingPhysicianAccountInformationComponent } from './account-information/non-buying-physician-account-information.component';
import { NonBuyingPhysicianUserInformationComponent } from './user-information/non-buying-physician-user-information.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NonBuyingPhysicianRootModule } from '../non-buying-physician.root.module';

@NgModule({
  declarations: [
    NonBuyingPhysicianAccountInformationComponent,
    NonBuyingPhysicianUserInformationComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    I18nModule,
    NgSelectModule,
    NgbPopover,
    NonBuyingPhysicianRootModule,
  ],
  providers: [],
  exports: [
    NonBuyingPhysicianAccountInformationComponent,
    NonBuyingPhysicianUserInformationComponent,
  ],
})
export class NonBuyingPhysicianRegistrationModule {}
